<template>
	<sf-modal-layout :title="getMessage_('SWCC000843')" :show="GuideBoardDetail" :closeModal="closeDetail" size="L">
		<el-row :gutter="30">
			<el-col :span="5">
				<sf-group-wrapper :label="getMessage_('SWCC000330')" labelPosition="left" :gutter="10" :labelSpan="7">
					<el-row :gutter="10">
						<el-col>
							{{ GuideBoardDetailValue.ver }}
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="6">
				<!-- 구분 -->
				<sf-group-wrapper :label="getMessage_('SWCC000844')" labelPosition="left" :gutter="10" :labelSpan="7">
					<el-row :gutter="10">
						<el-col>
							{{ GuideBoardDetailValue.category }}
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="7">
				<!-- 싱세구분 -->
				<sf-group-wrapper :label="getMessage_('SWCC000845')" labelPosition="left" :gutter="10" :labelSpan="9">
					<el-row :gutter="10">
						<el-col>
							{{ GuideBoardDetailValue.dtlCategory }}
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="6">
				<!-- 작성자 -->
				<sf-group-wrapper :label="getMessage_('SWCC000848')" labelPosition="left" :gutter="10" :labelSpan="8">
					<el-row :gutter="10">
						<el-col>
							{{ GuideBoardDetailValue.regId }}
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<el-row>
			<!-- 제목 -->
			<el-col :span="24">
				<sf-group-wrapper :label="getMessage_('SWCC000519')" :gutter="10" :labelSpan="5">
					<el-row :gutter="10">
						<el-col :span="24">
							{{ GuideBoardDetailValue.title }}
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<el-row>
			<!-- 내용 -->
			<el-col :span="24">
				<sf-group-wrapper :label="getMessage_('SWCC000846')" :gutter="10" :labelSpan="5">
					<el-row :gutter="10">
						<el-col :span="24" v-html="nl2br(GuideBoardDetailValue.conts)"> </el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<el-row>
			<!-- 파일 다운로드 link -->
			<el-col :span="24">
				<sf-data-table ref="link-table" :columns="columns" :rows="rows" sortable="false"> </sf-data-table>
			</el-col>
		</el-row>
		<el-row>
			<!-- 이미지 -->
			<el-col :span="24">
				<image-viewer v-if="GuideBoardDetailValue.imgList.length > 0" boxHeight="300px" :images="GuideBoardDetailValue.imgList">
				</image-viewer>
			</el-col>
		</el-row>
		<template v-slot:footer>
			<sf-button v-if="isButton_(scrId, 'CD')" line color="error" :onClick="deleteAction">{{ getMessage_('SWCC000107') }}</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" :onClick="updateAction">{{ getMessage_('SWCC000233') }}</sf-button>
			<sf-button line :onClick="closeDetail">{{ getMessage_('SWCC000113') }}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/GuideBoard/store/helpers';
import { ImageViewer } from './ImageViewer';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {},
	components: {
		ImageViewer
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('SWCC000924'), //파일명
					prop: 'fileName',
					minWidth: '50px',
					clickEvent: this.clickEvent,
					highlight: true,
					sortable: false
				}
			];
		},
		rows() {
			return this.GuideBoardDetailValue.fileInfo;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		deleteAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('SWCC000554'), //삭제하시겠습니까?
				buttons: [{ title: this.getMessage_('SWCC000107'), clickFn: () => this.delete() }] //삭제
			});
		},

		delete() {
			this.$sf_toggleLoading(true);
			this.delGuide_({ params: { ...this.GuideBoardDetailValue } })
				.then(response => {
					this.$sf_toast({ type: 'ok', message: response.message });
					this.getGuideBoardList_({ ...this.searchParams, currentPage: 1, pageUnit: this.groups.pageUnit });
					this.closeDetail();
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		updateAction() {
			this.defaultAssign_({ key: 'GuideBoardModalValue', value: { flg: 'U', ...this.GuideBoardDetailValue } });
			this.defaultAssign_({ key: 'GuideBoardDetail', value: false });
			this.defaultAssign_({ key: 'GuideBoardModal', value: true });
		},

		closeDetail() {
			this.closeDetail_();
		},

		nl2br(str) {
			return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
		},

		clickEvent(row) {
			this.fileDownload_({ no: row.boardNo, seq: row.seq })
				.then(response => {
					this.$sf_toast({ type: 'ok', message: 'File Download Successfully' });
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
<style>
span.caret-wrapper {
	display: none;
}
</style>
